import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Star } from "lucide-react";
import SafeImage from "@/components/SafeImage";

export default function StoreCard({ store }) {
  return (
    <Link to={`/store/${store.slug}`} className="group block surface overflow-hidden" data-testid={`store-card-${store.merchant_id}`}>
      <div className="aspect-[16/9] overflow-hidden bg-[#F3F2F0]">
        <SafeImage src={store.banner} alt={store.name} className="product-card-img w-full h-full object-cover" />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3">
          {store.logo && (
            <SafeImage src={store.logo} alt="" className="w-12 h-12 rounded-full object-cover border border-[#E5E3DD]" />
          )}
          <div className="flex-1">
            <h3 className="font-heading text-xl leading-tight">{store.name}</h3>
            <div className="flex items-center gap-3 text-xs text-[#5C5A56] mt-0.5">
              <span className="inline-flex items-center gap-1">
                <Star className="w-3.5 h-3.5 fill-[#C78B1B] text-[#C78B1B]" strokeWidth={1.5} />
                {store.rating?.toFixed(2)}
              </span>
              <span className="inline-flex items-center gap-1">
                <MapPin className="w-3.5 h-3.5" strokeWidth={1.5} />
                {store.location}
              </span>
            </div>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {store.types?.map((t) => (
            <span key={t} className="tag-pill bg-[#F2E8E9] text-[#702A32]">{t}</span>
          ))}
        </div>
        <p className="text-sm text-[#5C5A56] font-light mt-3 line-clamp-2">{store.description}</p>
      </div>
    </Link>
  );
}
